import { gql } from '@apollo/client';

export const REMOVE_RIPPLE = gql`
  mutation invalidateRipples($organization: String!, $ids: [String]!) {
    invalidateRipples(input: { clientMutationId: "1", organization: $organization, ids: $ids }) {
      clientMutationId
    }
  }
`;
